var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCssLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 45,
    viewBox: "0 0 106 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8281 11.1992H64.1152V18.4283H54.0573V25.6575H64.1152V32.8867H46.8281V11.1992Z",
    fill: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5703 11.1992H84.8574V17.4854H74.7995V18.7427H84.8574V33.201H67.5703V26.6005H77.6283V25.3432H67.5703V11.1992Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3203 11.1992H105.607V17.4854H95.5495V18.7427H105.607V33.201H88.3203V26.6005H98.3783V25.3432H88.3203V11.1992Z",
    fill: "#FEFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6758 39.9575L19.9046 44.3298L4.17675 39.9636L0.671875 0.652344H39.1844L35.6758 39.9575Z",
    fill: "#535353"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9297 40.9883L32.6736 37.4552L35.672 3.86719H19.9297V40.9883Z",
    fill: "#535353"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9245 18.4453H8.70312L9.13525 23.2666H19.9245V18.4453Z",
    fill: "#FEFEFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.909 8.6875H7.83594L8.27422 13.5089H19.9256V8.6875H19.909Z",
    fill: "#FEFEFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9043 30.9748L14.5347 29.525L14.1915 25.6797H11.5823H9.35156L10.027 33.2499L19.9032 35.9916L19.9254 35.9855V30.9692L19.9043 30.9748Z",
    fill: "#FEFEFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7079 13.5089L26.2692 18.4461H19.9141V23.2674H25.851L25.2914 29.5203L19.9141 30.9717V35.9878L29.7981 33.2484L29.8706 32.4338L31.0036 19.7407L31.1213 18.4461L31.9917 8.6875H19.9141V13.5089H26.7079Z",
    fill: "#FEFEFE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCssLogo);
export default __webpack_public_path__ + "static/media/css-logo.b3faea94799cfa1cc784926f7b397841.svg";
export { ForwardRef as ReactComponent };